module.exports = "/_next/static/images/game-1-intro-tutorial-underline1-54ac0316cb98ea8fe3775518b6fa1f02.png";